import { FC, useState } from "react"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers/DatePicker"
import dayjs, { Dayjs } from "dayjs"
import { Icon, IconColor } from "@/components/shared/Icon"
import "./index.scss"

interface DatePickerProps {
   selectedDate: Dayjs | null
   timezone: string
   minDate?: Dayjs
   maxDate?: Dayjs
   onDateChange: (newDate: Dayjs | null) => void
   label?: string
   showLabel?: boolean
   size?: "small" | "medium"
   format?: string
}

const DatePicker: FC<DatePickerProps> = ({
   selectedDate,
   timezone,
   minDate,
   maxDate = dayjs().tz(timezone),
   onDateChange,
   label,
   size,
   format,
}) => {
   const [open, setOpen] = useState(false)

   const CustomCalendarIcon = () => (
      <Icon
         size={"16"}
         name="calendar"
         color={IconColor.HONOLULU_BLUE}
      />
   )

   return (
      <div className="date-picker">
         <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MUIDatePicker
               label={label}
               value={selectedDate}
               defaultValue={dayjs().tz(timezone)}
               timezone={timezone}
               minDate={minDate}
               maxDate={maxDate}
               format={format}
               onChange={onDateChange}
               open={open}
               onOpen={() => setOpen(true)}
               onClose={() => setOpen(false)}
               slots={{ openPickerIcon: CustomCalendarIcon }}
               slotProps={{
                  textField: {
                     size,
                     onClick: () => setOpen(true),
                     className: "date-picker__input",
                     InputProps: {
                        readOnly: true,
                        sx: {
                           cursor: "pointer",
                           "& .MuiPickersSectionList-root": {
                              width: "unset",
                           },
                        },
                     },
                  },
                  field: {
                     readOnly: true,
                  },
                  actionBar: {
                     actions: ["today"],
                  },
               }}
            />
         </LocalizationProvider>
      </div>
   )
}

export default DatePicker
